/**
 * HOMEPAGE INTERACTIONS 2025
 * Performance-optimized animations and micro-interactions
 */
(function() {
  'use strict';

  var header = null;
  var isScrolled = false;
  var ticking = false;
  var isTouchLike = false;

  // Single shared observer for all reveal animations
  var revealObserver = null;
  
  function getRevealObserver() {
    if (revealObserver) return revealObserver;
    /**
     * PERFORMANCE FIX: Trigger animation BEFORE element enters viewport
     * 
     * rootMargin: '100px 0px 100px 0px'
     *   - 100px top: Start loading when 100px ABOVE viewport
     *   - 100px bottom: Start loading when 100px BELOW viewport
     * 
     * This eliminates the "flash" because content animates in
     * before user can see the invisible state.
     */
    revealObserver = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          if (el.dataset.countUp) {
            animateCountUp(el, parseInt(el.dataset.countUp) || 0);
          } else {
            el.classList.add('animate-in');
          }
          revealObserver.unobserve(el);
        }
      }
    }, { 
      threshold: 0.01,  // Trigger as soon as 1% visible (with margin)
      rootMargin: '100px 0px 100px 0px'  // Preload 100px before viewport
    });
    return revealObserver;
  }

  function animateCountUp(el, target) {
    var start = performance.now();
    var duration = 1500;
    function update(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(target * eased).toLocaleString();
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var href = anchor.getAttribute('href');
      if (href === '#' || href === '#0') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var headerH = header ? header.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, { passive: false });
  }

  function initScrollAnimations() {
    var els = document.querySelectorAll('.multicolumn-card, .reveal-item, [data-aos], [data-count-up]');
    if (!els.length) return;
    if (isTouchLike && document.body.classList.contains('template-index')) {
      for (var j = 0; j < els.length; j++) {
        if (els[j].dataset.countUp) {
          els[j].textContent = (parseInt(els[j].dataset.countUp, 10) || 0).toLocaleString();
        } else {
          els[j].classList.remove('animate-ready');
          els[j].classList.add('animate-in');
        }
      }
      return;
    }
    var obs = getRevealObserver();
    for (var i = 0; i < els.length; i++) {
      if (!els[i].dataset.countUp) els[i].classList.add('animate-ready');
      obs.observe(els[i]);
    }
  }

  function initCardHoverEffects() {
    var cards = document.querySelectorAll('[id*="category_banners"] .multicolumn-card');
    for (var i = 0; i < cards.length; i++) {
      cards[i].addEventListener('mouseenter', function() {
        this.style.willChange = 'transform';
      }, { passive: true });
      cards[i].addEventListener('mouseleave', function() {
        var el = this;
        setTimeout(function() { el.style.willChange = 'auto'; }, 200);
      }, { passive: true });
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var y = window.pageYOffset || window.scrollY || 0;
      var scrolled = isScrolled ? y > 24 : y > 80;
      if (scrolled !== isScrolled && header) {
        isScrolled = scrolled;
        header.classList.toggle('scrolled', scrolled);
      }
      ticking = false;
    });
  }

  function initLazyLoading() {
    if ('loading' in HTMLImageElement.prototype) {
      var imgs = document.querySelectorAll('img[loading="lazy"][data-src]');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].src = imgs[i].dataset.src;
      }
    }
  }

  function init() {
    header = document.querySelector('.xc-final-header');
    isTouchLike = !!(window.matchMedia && window.matchMedia('(pointer: coarse), (hover: none)').matches);
    initSmoothScroll();
    initScrollAnimations();
    initCardHoverEffects();
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    initLazyLoading();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.HomepageInteractions = { init: init };
})();
